<template>
	<div>
		<v-autocomplete
			background-color="white"
			box
			:disabled="disabled"
			:height="48"
			hide-details
			item-text="name"
			item-value="id"
			:items="customers"
			label="Cliente"
			:loading="isLoading"
			:readonly="disabled"
			return-object
			:search-input.sync="search"
			:value="newCustomerId"
			@input="setCustomerId"
		></v-autocomplete>
	</div>
</template>

<script>
	function created() {
		if (this.customerId) {
			this.newCustomerId = this.customerId;
			this.$emit('filter-customer', this.customerId, true);
		}
	}

	function search(value) {
		if (value) {
			const names = this.customerName.split(' ');
			const validName = names.every(n => n.toLowerCase() !== value.toLowerCase());
			if (validName) {
				this.$emit('filter-customer', value);
			}
		}
	}

	function setCustomerId({ id, lastname, name, company }) {
		this.newCustomerId = id;
		const fullName = `${name} ${lastname}`;
		this.$emit('set-customer-id', { id, fullName, company });
	}

	function data() {
		return {
			newCustomerId: 0,
			search: null,
		};
	}

	export default {
		name: 'company-filter',
		created,
		data,
		methods: {
			setCustomerId,
		},
		props: {
			customerId: [Number, String],
			customerName: String,
			customers: {
				default: () => [],
				type: Array,
			},
			disabled: {
				default: false,
				type: Boolean,
			},
			isLoading: {
				default: false,
				type: Boolean,
			},
		},
		watch: {
			search,
			$route(newVal) {
				if (newVal) {
					if (newVal.name === 'companies') {
						if (this.customerId) {
							this.newCustomerId = this.customerId;
							this.$emit('filter-customer', this.customerId, true);
						}
					}
				}
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/companies/company-filter.vue